import React from "react";
import style from "./homepage.scss"
import {contents} from "@/components/homePage/HomePageComponents";

const HomePagePanel = ({ photo}) => {
  return (
    <>
      <div className={style.photo}>
        { contents(photo) }
      </div>
    </>
  )
}
export default HomePagePanel
